// src/themes/tactical.js
//
// Tema Tactical — command center operativo auténtico.
// Phosphor P1 histórico sobre casi-negro, pensado para turnos nocturnos o
// condiciones de baja luz ambiente extrema.
//
// Referencia cromática: fósforo P1 de monitores CRT de centros de comando
// reales (NORAD, Houston Mission Control pre-digital, sistemas SAGE). El
// P1 emitía a ~525nm, produciendo verde con tinte amarillento de saturación
// moderada. NO es el neón fluorescente que popularizó Hollywood.
//
// Cambios estructurales respecto de la versión anterior:
//   - accent de #00FF88 (L 89, C 0.24, fuera de zona) a #6AD988 (L 76, C 0.17)
//   - bgDeep de #000000 a #060810 (lift mínimo para evitar halation extrema)
//   - uppercase ELIMINADO (ALL CAPS en body es 15-20% más lento de leer)
//   - monospace global ELIMINADO (se mantiene para datos tabulares vía clase
//     .data-mono en CSS, no como familia global del body)
//   - clusterMode colorful (antes monochrome perdía info operativa)
//   - accent/statusOnline/alertSuccess separados — los 3 estaban colapsados
//     en #00FF88. statusOnline y alertSuccess ahora vienen del Sistema B.
//   - shadows mantenidos pero reducidos (opacity y radius menores)

export default {
  id: 'tactical',
  label: 'Táctico (C4i)',
  mapBasemap: 'dark',

  // ========== SISTEMA A — CHROME ==========

  // Identidad — phosphor P1 auténtico, L 76 C 0.17 H 145
  accent:       '#6AD988',
  accentSoft:   'rgba(106, 217, 136, 0.20)',
  accentGlow:   'rgba(106, 217, 136, 0.50)',
  accentBright: '#8EE9A5',

  // Fondos — casi-negros con lift mínimo
  bgDeep:    '#060810',
  bgSurface: '#0B1015',
  bgCard:    '#040508',
  bgOverlay: 'rgba(6, 8, 16, 0.92)',

  // Texto — off-white con tinte phosphor muy sutil
  text:      '#DCE7E0',
  textMuted: '#8BA095',
  textDim:   '#5D6B63',

  // Bordes — tinte phosphor conservado pero suave
  borderDim:    'rgba(106, 217, 136, 0.06)',
  borderNormal: 'rgba(106, 217, 136, 0.12)',
  borderAccent: 'rgba(106, 217, 136, 0.40)',

  // Trail GPS — alineado al accent
  trailLine: '#6AD988',

  // Murphy themed — derivado del phosphor green accent. Solo se aplica si
  // el modo Murphy es 'themed'. En 'neutral' (default) ganan los grises.
  murphyLight: '#8EE9A5',
  murphyMid:   '#6AD988',
  murphyDeep2: '#3D8C53',
  murphyDeep1: '#1F5A30',
  murphyInk:   '#0A1A12',

  // ========== TOKENS EXTENDIDOS ==========

  // Tipografía: sin uppercase, sin monospace global. El monospace para datos
  // tabulares (timestamps, IDs, placas, coordenadas) se aplica vía clase
  // .data-mono en los componentes, no como familia global del body.
  fontFamily:         "'Public Sans', -apple-system, BlinkMacSystemFont, sans-serif",
  labelTransform:     'none',
  labelLetterSpacing: 'normal',

  // Shadows phosphor — mantenidos pero moderados respecto de la versión neón
  accentTextShadow: '0 0 6px rgba(106, 217, 136, 0.40)',
  alertTextShadow:  '0 0 8px rgba(232, 74, 61, 0.55)',
  accentBoxShadow:  '0 0 12px rgba(106, 217, 136, 0.28)',
  alertBoxShadow:   '0 0 16px rgba(232, 74, 61, 0.45), inset 0 0 10px rgba(232, 74, 61, 0.12)',

  // Rutas OSRM — unificadas con los otros temas
  routeActiveWidth:  4,
  routePreviewWidth: 2.5,

  // Clusters — colorful para preservar breakdown operativo a zoom bajo
  clusterMode: 'colorful',

  // ========== Categorías 911 (manual oficial federal CNIE v3.0) ==========
  // Versión tactical: tonos claros con buen contraste para overlays HUD.
  catSeguridad:         '#7AAAE8',  // azul claro
  catMedico:            '#7AC489',  // verde claro
  catProteccionCivil:   '#EBC745',  // amarillo dorado claro (separado de asistencia)
  catServiciosPublicos: '#A48EE0',  // morado claro
  catAsistencia:        '#E9844A',  // naranja-rojizo claro (separado de PC)
  catOtrosServicios:    '#8A96A4',  // gris claro
  catMalUso:            '#E07162',  // rojo-coral claro
}
